import React from "react";
import { TkAccordionProps } from "../../../type/componentsType/TkAccordion";
import { Accordion, Typography } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./_style.scss";

/**
 * アコーディオン部品
 * TkAccordionコンポーネントは、MUIのAccordionコンポーネントを拡張したものです。
 * @param {TkAccordionProps} props - TkAccordionPropsコンポーネントのプロパティ
 * @returns {JSX.Element} TkAccordionPropsコンポーネント
 */
export const TkAccordion: React.FC<TkAccordionProps> = (props) => {
  const {
    children,
    title,
    className,
    titleClassName,
    detailClassName,
    isShowExpandIcon = true,
    ...rest
  } = props;
  return (
    <Accordion
      elevation={1}
      {...rest}
      className={`MuiAccordion-root ${className}`}
    >
      <AccordionSummary
        expandIcon={isShowExpandIcon ? <ExpandMoreIcon /> : null}
        className={titleClassName}
      >
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={detailClassName}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default TkAccordion;
